// import Dashboard from "../Pages/Dashboard";
// import CompanyDetails from "../Components/CompanyDetails";
// import UsersDetails from "../Components/UserDetails";
// import LeadsDetails from "../Components/LeadDetails";
// import DemoDetails from "../Components/DemoDetails";
// import UserActivityDetails from "../Components/UserActivityDetails";
// import InvoicesDetails from "../Components/InvoicesDetails";
// import DataTable from "../Pages/DataTable";

// export const dashboardRoutes = [
//   {
//     label: "Dashboard",
//     path: "/dashboard",
//     element: <Dashboard />,
//   },
//   {
//     label: "Companies",
//     path: "/dashboard/companies",
//     element: <CompanyDetails />,
//   },
//   {
//     label: "Users",
//     path: "/dashboard/users",
//     element: <UsersDetails />,
//   },
//   {
//     label: "All Leads",
//     path: "/dashboard/leads",
//     element: <LeadsDetails />,
//   },
//   {
//     label: "Demo Requests",
//     path: "/dashboard/demo",
//     element: <DemoDetails />,
//   },
//   {
//     label: "User Activity",
//     path: "/dashboard/activity",
//     element: <UserActivityDetails />,
//   },
//   {
//     label: "Invoices",
//     path: "/dashboard/invoices",
//     element: <InvoicesDetails />,
//   },
 
//  {
//   label: "Company Table",
//   path: "/dashboard/:category/:id",
//   element: <DataTable />,
//   hidden: true,
// }
// ];

import Dashboard from "../Pages/Dashboard";

export const dashboardRoutes = [
  {
    label: "Dashboard",
    path: "/dashboard",
    element: <Dashboard />,
  },

];